import { render, staticRenderFns } from "./signBaodi.vue?vue&type=template&id=4ac5f9a3"
import script from "./signBaodi.vue?vue&type=script&lang=js"
export * from "./signBaodi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports